import angular from 'angular'

import component from './scene-status.component'

export default angular.module('scene-status', [
])
  .component('sceneStatus', component)
